import React from 'react'; // eslint-disable-line

const Eye = () => {
    return (
        <svg className="launch-preview" xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36">
            <g fill="none" fillRule="evenodd" stroke="#444" strokeLinecap="square" transform="translate(9 11)">
                <path d="M0,6 C0,6 3.429,0 8.571,0 C13.714,0 17.143,6 17.143,6 C17.143,6 13.714,12 8.571,12 C3.43,12 0,6 0,6 Z" id="Shape" />
                <circle id="Oval" cx="8.571" cy="6" r="2.571" />
            </g>
        </svg>
    );
};

export default Eye;
